import { render, staticRenderFns } from "./OrderGridOverview.vue?vue&type=template&id=07dbaba7&scoped=true&"
import script from "./OrderGridOverview.vue?vue&type=script&lang=js&"
export * from "./OrderGridOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrderGridOverview.vue?vue&type=style&index=0&id=07dbaba7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dbaba7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07dbaba7')) {
      api.createRecord('07dbaba7', component.options)
    } else {
      api.reload('07dbaba7', component.options)
    }
    module.hot.accept("./OrderGridOverview.vue?vue&type=template&id=07dbaba7&scoped=true&", function () {
      api.rerender('07dbaba7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/OrderGridOverview.vue"
export default component.exports